import { useCallback, useState } from 'react';

export default function useVisible(initialValue = false) {
  const [visible, setVisible] = useState<boolean>(initialValue);

  const show = useCallback(() => {
    setVisible(true);
  }, []);

  const hide = useCallback(() => {
    setVisible(false);
  }, []);

  const toggle = useCallback(() => {
    setVisible(!visible);
  }, [visible]);

  return { visible, show, hide, toggle };
}
